
import { ColorPickerPanel } from 'markerjs2';
import { Subscription } from 'rxjs';

import { AdvancedColorPickerPopoverComponent } from '../../../../../Common/Forms/components/AdvancedColorPickerPopover/advanced-color-picker-popover.component';
import { ColorModel } from '../../../../../Common/Forms/models/color.model';
import { ColorChangeModel } from '../../../../../Common/Forms/models/color-change.model';


export class ChartAnnotationColorPickerPanel extends ColorPickerPanel {

    colorPickerPanel: AdvancedColorPickerPopoverComponent;
    currColor: string;
    markerArea: any;

    colorChangeSubscription: Subscription;

    constructor(
        title: string,
        colors: string[],
        currentColor?: string,
        icon?: string,
        component?: AdvancedColorPickerPopoverComponent,
        markerArea?: any
    ) {
        super(
            title,
            colors,
            currentColor,
            icon
        );
        this.colorPickerPanel = component;
        this.currColor = currentColor;
        this.markerArea = markerArea;
    }

    getUi(): HTMLDivElement {
        this.colorPickerPanel.colorModel = new ColorModel(
            this.currColor,
            ColorModel.HEXtoRGB(this.currColor),
            ColorModel.HEXtoHSB(this.currColor)
        );
        const container = this.colorPickerPanel.container;

        const toolboxPanel = this.markerArea.toolbox.panelRow;
        if (toolboxPanel) {
            toolboxPanel.style.background = 'transparent';
            toolboxPanel.style.height = '340px';
        }

        if (this.colorChangeSubscription) {
            this.colorChangeSubscription.unsubscribe();
            this.colorChangeSubscription = null;
        }
        this.colorChangeSubscription = this.colorPickerPanel.colorChange.subscribe((change: ColorChangeModel) => {
            if (this.onColorChanged && change?.value) {
                this.currColor = change.value;
                this.onColorChanged(change.value);
            }
        });

        return container;
    }
}
